import { jwtDecode } from "jwt-decode"

export function getAdminSessionIdentity(token) {
  try {
    if (typeof token !== "string" || token.split(".").length !== 3 || token.split(".").some(part => !part)) return null
    const identity = jwtDecode(token)
    if (!Number.isSafeInteger(identity.user_id) || identity.user_id <= 0 ||
      typeof identity.user_name !== "string" || !identity.user_name.trim() ||
      typeof identity.scope !== "string") return null
    if (identity.exp !== undefined && (!Number.isSafeInteger(identity.exp) || identity.exp <= Date.now() / 1000)) return null
    return identity
  } catch {
    return null
  }
}

export function validateAdminLoginResponse(response) {
  const token = response?.access_token
  if (!getAdminSessionIdentity(token)) {
    throw new Error("The API returned an invalid login session. Please sign in again.")
  }
  return token
}
